import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';
import WorkflowStatusOverviewModal from 'modules/common/modals/workflowStatusOverviewModal/WorkflowStatusOverviewModal';

import { useFeatureFlagValue } from 'store/session/hooks';

import WorkflowTable from './WorkflowTable';
import { dashboard } from './data/actions';
import {
  getPageSize,
  getTotalCount,
  getIsWorkflowLoading,
} from './data/reducer';

const WorkflowDashboard = () => {
  const dispatch = useDispatch();
  const pageSize = useSelector(getPageSize);
  const totalCount = useSelector(getTotalCount);
  const isWorkflowLoading = useSelector(getIsWorkflowLoading);
  const isPriorityEnabled = useFeatureFlagValue(
    featureFlagKeys.isQuotePriorityAvailable,
  );

  useEffect(() => {
    dispatch(dashboard.init());
  }, [dispatch]);

  const onChange = useCallback(
    ({ filters, page }) => {
      dispatch(dashboard.update({ filters, page }));
    },
    [dispatch],
  );

  return (
    <>
      <WorkflowStatusOverviewModal showGoToQuoteLink />
      <WorkflowTable
        isPriorityEnabled={isPriorityEnabled}
        onChange={isWorkflowLoading ? null : onChange}
        pagination={{
          pageSize,
          totalCount,
        }}
      />
    </>
  );
};

export default WorkflowDashboard;
